var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SlSwitchNav',{attrs:{"navs":_vm.switchNavs,"default-active":_vm.activeComponent},on:{"select":_vm.switchNav}}),_c('keep-alive',[_c(_vm.activeComponent,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }